/**
 * Shared utility for downloading sketch as JSON
 * Used by Header, MobileLayout, and MobileHeader
 */
export function downloadSketch(sketchName, files) {
  const sketch = {
    name: sketchName,
    files: files.map(f => ({
      name: f.name,
      content: f.content
    }))
  }
  
  const blob = new Blob([JSON.stringify(sketch, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${sketchName}.json`
  a.click()
  URL.revokeObjectURL(url)
}
